export default __webpack_public_path__ + "static/media/drag.ba2e9e46.svg";